(function () {
  const sections = document.querySelectorAll('.featured-collection-section');
  if (!sections.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    for (const section of sections) {
      for (const card of section.querySelectorAll('[data-featured-collection-card]')) {
        card.classList.add('featured-collection-card--visible');
      }
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('featured-collection-card--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.25, rootMargin: '0px 0px -20px 0px' }
  );

  for (const section of sections) {
    for (const card of section.querySelectorAll('[data-featured-collection-card]')) {
      observer.observe(card);
    }
  }
})();
